(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_lumajo-in-action-video"] && !Shopify.designMode) return;
  try {
    class LumajoActionCard extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const unmuteButton = this.querySelector('[data-unmute]');

      if (unmuteButton) {
        unmuteButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (video) {
            video.muted = !video.muted;
          }
        });
      }
    }
  }

  if (!customElements.get('lumajo-action-card')) {
    customElements.define('lumajo-action-card', LumajoActionCard);
  }
  } catch(e) { console.error(e); }
})();

})();
